module.exports = __webpack_public_path__ + "static/img/wandoujia.db04b829.png";